import { MESSAGES } from "@app/constant";
import { throwImageFiltering } from "@app/helpers/uploadFileValidation";

import { handleDeleteImageProps, onChangeUploadProps } from "./types";

export const onChangeUpload = ({
  event,
  setValue,
  setState,
  setError,
  images
}: onChangeUploadProps) => {
  setState((prev) => ({ ...prev, largeImageMessage: '' }))

  try {
    const fileList = event.target?.files as FileList;
    const onChangeFiles = throwImageFiltering(fileList)
    const chosenImagesLength = Object.keys(onChangeFiles || {}).length

    if (!onChangeFiles) {
      setError('images', { message: MESSAGES.imageIsRequired })
    }

    if (((images?.length || 0) + chosenImagesLength) > 5) {
      setError('images', { message: MESSAGES.notMoreFiveImage })

      return
    }

    if (fileList.length !== onChangeFiles.length) {
      setState((prev) => ({ ...prev, largeImageMessage: MESSAGES.imageSize }))
    }

    const mergedFileList = new DataTransfer();

    Array.from(images || []).forEach((file) => mergedFileList.items.add(file));
    Array.from(onChangeFiles).forEach((file) => mergedFileList.items.add(file));

    setValue('images', mergedFileList.files)
  } catch (error) {
    console.log('Error:', error);
  }
}

export const handleDeleteImage = ({
  bas64,
  previews,
  setValue,
  setState,
  images,
}: handleDeleteImageProps) => {
  const index = previews.findIndex((item) => item === bas64);

  const files = Array.from(images).filter((_, i) => i !== index);

  const mergedFileList = new DataTransfer();

  files.forEach((file) => {
    mergedFileList.items.add(file);
  });

  setValue('images', mergedFileList.files)
  setState((prev) => ({ ...prev, isDeleteModalOpen: false }))
}
